/* eslint-disable */
export default {
  unknown: 'Inconnu',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
